import {MeetingCommentFile} from './MeetingCommentFile'
import NewMeetingComment from './NewMeetingComment'
import {InputError} from '../components/AdminMeetingCommentInputForm'
import {SubmitCommentAndFilesTemplateForAdmin} from './SubmitCommentAndFilesTemplateForAdmin'
import {MeetingRepositoryForAdmin} from '../MeetingRepositoryForAdmin'
import {AsyncCallFunctionType, AsyncFunction} from '../../shared/hoc/withAsyncCommunication'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import {FileDataForValidate} from './FileDataForValidate'
import {Nullable} from '../../../app/TypeHelpers'

interface SendData {
    condominiumCd: string
    meetingId: number
    replySourceId: number
    newMeetingCommentReply: NewMeetingComment
}

export class SubmitNewCommentReplyProcedureForAdmin extends SubmitCommentAndFilesTemplateForAdmin<SendData> {
    meetingRepoForAdmin: MeetingRepositoryForAdmin

    constructor(
        registerCommentError: (inputError: InputError) => void,
        meetingRepositoryForAdmin: MeetingRepositoryForAdmin,
        asyncCallFunction: AsyncCallFunctionType,
        eventEmitter: EventEmitterExAdmin,
    ) {
        super(registerCommentError, asyncCallFunction, eventEmitter)
        this.meetingRepoForAdmin = meetingRepositoryForAdmin
    }

    registerCommentFunction(sendData: SendData): AsyncFunction<any, number> {
        return () => this.meetingRepoForAdmin.registerCommentReply(
            sendData.condominiumCd,
            sendData.meetingId,
            sendData.replySourceId,
            sendData.newMeetingCommentReply,
        )
    }

    validateFileFunction(fileDataForValidate: FileDataForValidate): AsyncFunction<any, void> {
        return () => this.meetingRepoForAdmin.validateParallelFileUpload(fileDataForValidate)
    }

    async registerFile(sendData: SendData, commentId: number, commentFile: MeetingCommentFile): Promise<void> {
        // NatAsyncCallFunctionによる標準の通信エラー処理を行わない
        // 原因はなんであれファイルを再登録する必要があることをユーザーに伝える必要があるため、全ての例外を捕捉する
        await this.meetingRepoForAdmin.registerCommentReplyFile(
            sendData.condominiumCd,
            sendData.meetingId,
            sendData.replySourceId,
            commentId,
            commentFile,
        )
    }

    async submit(
        condominiumCd: string,
        meetingId: number,
        replySourceId: number,
        newMeetingCommentReply: NewMeetingComment,
        commentFileList: MeetingCommentFile[],
    ): Promise<Nullable<number>> {
        this.commentId = null
        await this.process(
            {
                condominiumCd: condominiumCd,
                meetingId: meetingId,
                replySourceId: replySourceId,
                newMeetingCommentReply: newMeetingCommentReply,
            },
            commentFileList,
        )

        return this.commentId
    }
}
